import React from "react";
import {
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});
Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontFamily: "Roboto",
    position: "relative",
    paddingTop: 110,
    paddingBottom: 100,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -10,
    right: 0,
    width: 280,
    marginBottom: 80,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
    marginTop: "20px",
  },
  mainContent: {
    flex: 1,
    alignContent: "center",
    marginTop: 0,
    marginBottom: 0,
    paddingHorizontal: 40,
  },
  heading: {
    fontSize: 23,
    fontWeight: "bold",
    marginBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    paddingBottom: 6,
    width: "100%",
  },
  subheading: {
    fontSize: 16,
    marginBottom: 20,
  },
  careerBlock: {
    marginBottom: 15,
  },
  careerTitle: {
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 4,
    marginLeft: 12,
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: "bold",
    marginLeft: 20,
    marginTop: 4,
    marginBottom: 2,
    color: "#444",
  },
  listItem: {
    marginLeft: 28,
    flexDirection: "row",
    marginBottom: 2,
  },
  bulletPoint: {
    width: 8,
    fontSize: 11,
  },
  listText: {
    flex: 1,
    fontSize: 11,
    lineHeight: 1.4,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});

const CertificationsPDF = ({ certifications, assets, showPageNumber }) => {
  return (
    <Page size="A4" style={styles.page}>
      <Image src={assets.upper} style={styles.upperDesign} fixed />
      <Image src={assets.lower} style={styles.lowerDesign} fixed />
      <Image src={assets.logo2} style={styles.logo2} fixed />

      <View style={styles.mainContent}>
        <Text style={styles.heading}>
          Certifications & Learning Platforms
        </Text>
        <Text style={styles.subheading}>
          Build your skills and portfolio with these recommendations:
        </Text>

        {certifications?.map((item, idx) => (
          <View key={idx} style={styles.careerBlock}>
            <Text style={styles.careerTitle}>• {item.career_pathway}</Text>

            <Text style={styles.sectionLabel}>Certifications:</Text>
            {item.certifications?.map((cert, i) => (
              <View key={i} style={styles.listItem}>
                <Text style={styles.bulletPoint}>–</Text>
                <Text style={styles.listText}>{cert}</Text>
              </View>
            ))}

            <Text style={styles.sectionLabel}>Learning Platforms:</Text>
            {item.learning_platforms?.map((platform, i) => (
              <View key={i} style={styles.listItem}>
                <Text style={styles.bulletPoint}>–</Text>
                <Text style={styles.listText}>{platform}</Text>
              </View>
            ))}

            <Text style={styles.sectionLabel}>Portfolio Projects:</Text>
            {item.portfolio_projects?.map((project, i) => (
              <View key={i} style={styles.listItem}>
                <Text style={styles.bulletPoint}>–</Text>
                <Text style={styles.listText}>{project}</Text>
              </View>
            ))}
          </View>
        ))}
      </View>

      {showPageNumber && (
        <View style={styles.pageNumber_Box} fixed>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `${pageNumber}`}
            fixed
          />
        </View>
      )}
    </Page>
  );
};

export default CertificationsPDF;
